import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTractorsNearDestinationReport extends Layout {
    checkboxBreakOnGroupBy: Checkbox;
    checkboxIncludeDelivered: Checkbox;
    excludabletextboxFleets: ExcludableTextbox;
    excludabletextboxOpsUser: ExcludableTextbox;
    excludabletextboxStates: ExcludableTextbox;
    excludabletextboxTractorDisp: ExcludableTextbox;
    excludabletextboxZones: ExcludableTextbox;
    sourceTractorsNearDestination: DataSource;
    switchStateZone: Switch;
    textboxGroupBy: Textbox;
    textboxMilesFromDest: Textbox;
}
